<template>
    <div id="osm-map" ref="osmMap"></div>
  </template>
  
  <script>
  import L from 'leaflet';
  import 'leaflet/dist/leaflet.css';

  const myIcon = L.icon({
  iconUrl: require('@/assets/maps-and-flags.png'),
  iconRetinaUrl: require('@/assets/maps-and-flags.png'),
  iconSize: [25, 25],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-shadow.png',
  shadowSize: [41, 41]
});

  export default {
    name: 'LeafletMap',
    mounted() {
      // Get the map container element via ref
      const element = this.$refs.osmMap;
      // Ensure the element has a height (or set it via CSS)
      element.style.height = '300px';
  
      // Create the Leaflet map on the element.
      const map = L.map(element);
  
      // Add OpenStreetMap tile layer to the map.
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);
  
      // Set target coordinates (using 62.99, 17.64 as per your OpenStreetMap URL).
      const target = L.latLng(55.7249235, 13.0791973);
  
      // Center the map on target with a zoom level of 14.
      map.setView(target, 14);
  
      // Place a marker at the target location.
      var marker = L.marker(target, { icon: myIcon }).addTo(map);
      marker.bindPopup("<b>Flädie Mat & Vingård</b><br>Flädie Mejeriväg 19").openPopup();

    }
  }
  </script>
  
  <style scoped>
  #osm-map {
    width: 100%;
    height: 300px; /* fallback height */
  }
 
  </style>
  